import Map from "@commons/Map";
import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetCollarLogsGeoJson } from "@services/device/collar/getGeoJsonLog";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { toast } from "react-toastify";
import { config } from "@/config";

type HeatmapViewProps = {
  latitude?: number;
  longitude?: number;
};

function HeatmapView({
  latitude = config.map.latitude,
  longitude = config.map.longitude,
}: HeatmapViewProps) {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, error } = useGetCollarLogsGeoJson(id || "");

  useEffect(() => {
    if (error) {
      toast.error("Erro ao carregar mapa de calor. Tente novamente.");
    }
  }, [error]);

  if (error) {
    return (
      <div className="w-full h-[40dvh] flex flex-col items-center justify-center">
        <ErrorOutlineIcon className="text-red-500 mb-2 text-6xl" />
        <span className="text-red-600 text-center">
          Ocorreu um erro ao carregar o mapa de calor.
        </span>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="w-full h-[40dvh] flex flex-col items-center justify-center gap-4">
        <CircularProgress size={48} sx={{ color: "#14b8a6" }} />
        <span className="text-gray-600">Carregando mapa de calor...</span>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="w-full h-[40dvh] flex flex-col items-center justify-center">
        <span className="text-gray-500">
          Nenhum dado disponível para exibir
        </span>
      </div>
    );
  }

  return (
    <div className="w-full h-[40dvh] flex justify-center items-center">
      <Map.Root>
        <Map.Heatmap
          longitude={longitude}
          latitude={latitude}
          zoom={12}
          geojsonData={data}
          weightProperty="recordedAt"
        />
      </Map.Root>
    </div>
  );
}

export default HeatmapView;
